function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPenyesaLogoWhite = function SvgPenyesaLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 255.93 243.24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M124.08,221.32a92.88,92.88,0,0,1-92.87-92.4H9.72l17.43,18.81L18,172.38l23.91,11,1,26.29,26.28,1,11,23.92,24.65-9.16,19.29,17.87,19.3-17.87L168,234.53,179,210.61l26.28-1,1-26.28,23.91-11L221,147.73l17.41-18.8H217A92.89,92.89,0,0,1,124.08,221.32Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.17,84.49,206.26,73.54l-1-26.28-26.28-1L168,22.34,143.38,31.5l-19.3-17.87L104.79,31.5,80.14,22.34l-11,23.92-26.28,1-1,26.28L18,84.49l9.16,24.65L9.76,127.92H31.21a92.88,92.88,0,0,1,185.75,0h21.46L221,109.14Z",
    style: {
      fill: "#5b4e03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.15,35.56a92.87,92.87,0,0,0-92.88,92.36H221A92.87,92.87,0,0,0,128.15,35.56Z",
    style: {
      fill: "#daba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,127.94c9.85,62,63.39,109.42,128,109.42s118.12-47.4,128-109.42Z",
    style: {
      fill: "#5b4e03"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.41 106.86 243.43 87.97 246.66 79.26 238.22 75.4 219.9 67.01 219.13 46.88 218.78 37.62 209.52 37.26 189.39 36.5 181 18.18 177.13 9.74 168.43 12.97 149.54 19.98 134.76 6.29 127.96 0 121.17 6.29 106.39 19.98 87.5 12.97 78.79 9.74 74.92 18.18 66.53 36.5 46.4 37.26 37.14 37.62 36.79 46.88 36.02 67.01 17.71 75.4 9.26 79.26 12.49 87.97 19.51 106.86 5.82 121.64 0.01 127.92 13.63 127.92 31.02 109.14 21.87 84.49 45.78 73.54 46.78 47.26 73.06 46.26 84.01 22.34 108.67 31.5 127.96 13.63 147.25 31.5 171.91 22.34 182.86 46.26 209.14 47.26 210.14 73.54 234.05 84.49 224.9 109.14 242.3 127.94 255.93 127.94 250.1 121.64 236.41 106.86",
    style: {
      fill: "#e6ddad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.58,150c0,1.17-.2,14.41-.24,18.59-3.77-3.89-18.4-19.09-19.38-20.21l-.22-.17H90l-.1,1.89c-.28,5.83-1.13,23.57-1.3,26.11l0,.49,4.55.34,0-.56c0-.76.09-8.43.17-14,0-2.25.07-4.24.08-5.47,3.84,4.13,19.57,20.23,19.73,20.39l.22.15h.7V177c.15-9.43.85-24.52,1-26.8l0-.5-4.48-.24Z",
    style: {
      fill: "#daba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25,172.91c-2.51.19-6.44.14-8.11.12h-.28V165l3,.07,3.84.08h.52l-.15-4-.54.07c-1.55.19-5.28.35-6.7.39v-8.44l2.57-.06c2.1-.06,4.72-.12,5.41-.12h.53l-.2-4-.54.07c-1.16.14-10.83.7-11.73.7h-.53l0,.52c0,.7.11,9.74.11,10.25v5c0,1.47,0,8.9-.11,10.76l0,.53h.53c.39,0,3.8.11,6.81.2l5.73.17H82l-.19-4.23Z",
    style: {
      fill: "#daba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.55,150.19h0a50.93,50.93,0,0,0-7.08-.49H46v.5c0,.25,0,1.85.05,3.63,0,2.19.06,4.64.06,5.11V163c0,2.67-.11,11.6-.18,13.19l0,.52h4.57l-.06-.55c0-.48-.07-2.5-.07-5.53v-1.79c7.16-1.55,11.76-5.86,11.76-11.05C62.08,153.8,59.05,151.09,53.55,150.19Zm-3.23,15V153.47c6.8.28,7.15,4.13,7.15,4.91C57.47,162.71,53.24,164.51,50.32,165.23Z",
    style: {
      fill: "#daba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6,161.53l-.39-.23-.69-.4c-1.46-.82-3.27-1.84-3.27-3.22,0-2.69,5.05-4.42,7.36-4.79l.54-.09-1.05-3.86-.47.1c-5.28,1.2-11,5.08-11,9.27,0,3.06,2.66,4.75,5.62,6.35s3.61,2.36,3.61,3.84c0,2.6-4.26,4.39-7.9,5.13l-.56.11,1.31,3.76.43-.1c7.88-1.85,11.4-6.25,11.4-9.79C182.55,164.45,180.26,163.1,177.6,161.53Z",
    style: {
      fill: "#daba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.72,174.55c-1.28-2-4.15-7.18-7.18-12.72-2.87-5.21-5.82-10.6-7.43-13.2l-.23-.23h-.55l-.15.23c-.43.68-3,5.6-5.9,11.3-3.14,6.07-6.69,13-7.76,14.83l-.24.42,3.93,2.48.24-.49c.28-.55,1-2.19,1.76-3.93.83-1.89,1.84-4.19,2.23-5l12.33-.5c.63,1.11,2.9,5.47,4,7.67l1.14,2.18,4-2.66Zm-19.5-9.75c.26-.52.63-1.3,1.12-2.33,1-2.16,2.5-5.2,3.23-6.63,1,1.91,3.58,6.73,4.55,8.59Z",
    style: {
      fill: "#daba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4,149.13a20.34,20.34,0,0,0-7.36,5h0a21.86,21.86,0,0,0-4.13,6.45,24.77,24.77,0,0,0-4.54-6.94,23.94,23.94,0,0,0-5.94-4.46l-.44-.23-2,3.82.5.21a15.93,15.93,0,0,1,5.29,4,16.84,16.84,0,0,1,4.67,11.2V171c0,.46-.15,4.4-.19,5.26l0,.52H134l-.06-.55c-.07-.73-.18-4-.18-4.53v-3.49a16.52,16.52,0,0,1,4.16-10.5,15.19,15.19,0,0,1,6.86-4.69l.52-.15L143.85,149Z",
    style: {
      fill: "#daba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.08,172.91c-2.52.19-6.44.14-8.12.12h-.27V165l3,.07,3.84.08h.52l-.15-4-.54.07c-1.55.19-5.28.35-6.69.39v-8.44l2.57-.06c2.1-.06,4.72-.12,5.41-.12h.53l-.21-4-.53.07c-1.16.14-10.84.7-11.73.7h-.53l0,.52c0,.7.11,9.74.11,10.25v5c0,1.47,0,8.9-.11,10.76l0,.53h.53c.38,0,3.79.11,6.8.2l5.73.17h.53l-.2-4.23Z",
    style: {
      fill: "#daba27"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(88.81 205.77)",
    style: {
      fontSize: "22.77252960205078px",
      fill: "#daba27",
      stroke: "#daba27",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px",
      fontFamily: "Microsoft-Yi-Baiti, Microsoft Yi Baiti",
      fontStyle: "italic",
      letterSpacing: "0.05999381541596353em"
    }
  }, "PANTRY"), /*#__PURE__*/React.createElement("polygon", {
    points: "164.9 68.11 164 62.71 147.84 64.94 140.81 95.8 102.25 100.62 94.73 72.92 91.39 72.92 98.28 104.89 145.78 101.63 152.8 69.67 164.9 68.11",
    style: {
      fill: "#3e3a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.32,104.05a7.69,7.69,0,1,0,7.69,7.69A7.68,7.68,0,0,0,137.32,104.05Zm0,11.88a4.2,4.2,0,1,1,4.2-4.19A4.19,4.19,0,0,1,137.32,115.93Z",
    style: {
      fill: "#3e3a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,106.14a6.64,6.64,0,1,0,6.64,6.64A6.64,6.64,0,0,0,106,106.14Zm0,10.64a4,4,0,1,1,4-4A4,4,0,0,1,106,116.78Z",
    style: {
      fill: "#3e3a27"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPenyesaLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PenyesaLogoWhite.c593d73d.svg";
export { ForwardRef as ReactComponent };